import TransferList from "./components/TransferList";
import HistoryDetailList from "./components/HistoryDetailList";
import { useHistory , useParams } from "react-router-dom";
import React, { useState, useRef, useEffect, useCallback } from "react";
import { Button, InputItem, List, Modal, Toast, WhiteSpace } from "antd-mobile";
import instance from "../../../../util/axios";
import { Result } from "../../../../schema";
import DictionarySelect from "../../../../component/CheckBoxItem";
import "../main.css";
import moment from "moment";

export default function CompletionList() {
  const [step, setStep] = useState<1 | 2>(1);
  const CompletionListRef = useRef<any>();
  const history = useHistory();
  const [submitForm, setSubmitForm] = useState<{
    visible: boolean;
    workshopId: any;
  }>({
    visible: false,
    workshopId: "",
  });

  const params = useParams<{
    fillingId: string;
  }>();

  const descriptionNoCutting = [
    {
      fieldName: "serialNumber",
      fieldShowName: "批号",
      width: 120,
    },
    {
      fieldName: "dealerId",
      fieldShowName: "客户名称",
      width: 120,
      inputType: 6,
      dictionary: "rad_dealer",
    },
    {
      fieldName: "radId",
      fieldShowName: "产品",
      width: 120,
      inputType: 6,
      dictionary: "rad_sku",
    },
    {
      fieldName: "custom_text_1",
      fieldShowName: "规格",
      width: 120,
    },
    {
      fieldName: "custom_text_2",
      fieldShowName: "排档方式",
      width: 120,
    },
    {
      fieldName: "color",
      fieldShowName: "表面处理",
      width: 120,
      inputType: 6,
      dictionary: "dict_rad_color",
    },
    {
      fieldName: "formulaName",
      fieldShowName: "图号",
      width: 120,
    },
    {
      fieldName: "completeTime",
      fieldShowName: "完成日期",
      width: 120,
    },
    {
      fieldName: "orderDate",
      fieldShowName: "订单交期",
      width: 120,
    },
    {
      fieldName: "produceQuantity",
      fieldShowName: "数量",
      width: 120,
    },
    {
      fieldName: "outAmount",
      fieldShowName: "已转移数量",
      width: 120,
    },
    {
      fieldName: "inAmount",
      fieldShowName: "接收转移的数量",
      width: 120,
    },
  ];
  const onsave = useCallback((status: string) => {
    let onSelectRows = CompletionListRef.current.getCheckedItem();
    let arr: any = [];
    onSelectRows.forEach((item: any) => {
      arr.push({
        orderId: item.orderId,
        detailId: item.detailId,
        radId: item?.ref?.radId,
        custom_text_1: item.custom_text_1,
        custom_text_2: item.custom_text_2,
        custom_text_3: item.custom_text_3,
        custom_text_4: item.custom_text_4,
        color: item?.ref?.color,
        formulaName: item.formulaName,
        produceQuantity: item.produceQuantity,
        amount: item.amount,
        serialNumber:item.serialNumber,
        completeTime:item.completeTime,
        orderDate:item.orderDate,
        dealerId:item.dealerId,
        fillingId:item.fillingId,
      });
    });
    instance
      .post(`/erp/sku/workshop/insertWorkshopTransferList?status=`+status, {
        outWorkshopId: "0427c23fe35f400e9b423e72e5fc0cac",
        inWorkshopId: submitForm?.workshopId,
        completionListJson: JSON.stringify(arr),
        fillingId:params.fillingId
      })
      .then((resp: any) => {
        if (resp.data?.Status === "1") {
          if( status !== "save" ){
            Toast.success("转移成功！");
            var ids = resp.data.Data.split(",");
            for (let i = 0; i < ids.length; i++) {
              instance
                .post("/wf/form/vsheet/submit", {
                  id: ids[i],
                  name: "车间转移单",
                })
                .then((data) => {
                  if (data.data.Status === "1") {
                    
                  } else {
                    Toast.fail(
                      "车间转移单自动提交审核失败！失败原因：" +
                        data.data.Data
                    );
                  }
                });
            }
          }else{
            Toast.success("保存成功！");
          }
          setStep(1);
          CompletionListRef.current.clearCheckedItem();
          CompletionListRef.current.refresh();
          setSubmitForm((prevState) => ({
            ...prevState,
            visible: false,
            workshopId: "",
            status:status,
          }));
        }
      });
  }, [submitForm?.workshopId]);
  return (
    <>
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div style={{ flex: 1, overflowY: "auto" }}>
          <TransferList
            url={
              `/erp/sku/workshop/getCompletionTransferFillingList?workshopId=0427c23fe35f400e9b423e72e5fc0cac&type=110&fillingId=${params?.fillingId}`
            }
            ref={CompletionListRef}
            rowSelectionType="checkbox"
            descriptions={descriptionNoCutting}
          />
        </div>
        {false ? (
          <Button
            style={{ width: "100%", zIndex: 99 }}
            type="primary"
            onClick={() => {
              let onSelectRows = CompletionListRef.current.getCheckedItem();
              if (onSelectRows.length === 0) {
                Toast.fail("请您至少选择一条数据再确定！");
                return;
              }
              setStep(2);
            }}
          >
            转移清单
          </Button>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
              background: "#fff",
            }}
          >
            <Button
              style={{ width: "30%", zIndex: 99 }}
              onClick={() => {
                let onSelectRows = CompletionListRef.current.getCheckedItem();
                if (onSelectRows.length === 0) {
                  Toast.fail("请您至少选择一条数据再确定！");
                  return;
                }
                onsave("save")
              }}
            >
              保存
            </Button>

            <Button
              style={{ width: "30%", zIndex: 99 }}
              type="primary"
              onClick={() => {
                let onSelectRows = CompletionListRef.current.getCheckedItem();
                if (onSelectRows.length === 0) {
                  Toast.fail("请您至少选择一条数据再确定！");
                  return;
                }
                let emptyFlag = false;
                onSelectRows.forEach((item: any) => {
                  if (item.amount === undefined || item.amount === "") {
                    emptyFlag = true;
                  }
                });
                if (emptyFlag) {
                  Toast.fail("您选中的订单未填写本次转移数量！");
                  return;
                }
                setSubmitForm((prev) => ({
                  ...prev,
                  visible: true,
                }));
              }}
            >
              提交转移
            </Button>
            <Button
              style={{ width: "30%", zIndex: 99 }}
              type="primary"
              onClick={() => {
                //setStep(1);
                history.go(-1);
                CompletionListRef.current.clearCheckedItem();
              }}
            >
              返回
            </Button>
          </div>
        )}
      </div>
      <Modal
        title={"选择车间"}
        visible={submitForm.visible}
        onClose={() => {
          setSubmitForm((prev) => ({
            ...prev,
            visible: false,
            workshopId: "",
          }));
        }}
        transparent
        maskClosable={false}
        closable={true}
        footer={[
          {
            text: "取消",
            onPress: () => {
              setSubmitForm((prev) => ({
                ...prev,
                visible: false,
                workshopId: "",
              }));
            },
          },
          {
            text: "提交",
            onPress: async () => {
              if (!submitForm?.workshopId) {
                Toast.fail("请填写转出车间！");
                return;
              }
              onsave("submit");
            },
          },
        ]}
      >
        <List>
          <DictionarySelect
            title={"选择车间"}
            multiple={false}
            dictionary={"erp_workshop"}
            value={submitForm.workshopId}
            onChange={(value) => {
              setSubmitForm((prevState: any) => ({
                ...prevState,
                workshopId: value,
              }));
            }}
          />
        </List>
      </Modal>
    </>
  );
}
